export const GLOSSARY = [
  {
    "key": 1,
    "value": "Access control list (ACL)",
    "description": "A list of permissions associated with a system resource that specifies which users or system processes are granted access and what operations they are allowed to perform."
  },
  {
    "key": 2,
    "value": "Access recertification",
    "description": "A periodic review process where managers verify that user access rights remain appropriate and aligned with current job responsibilities."
  },
  {
    "key": 3,
    "value": "Accounting",
    "description": "Tracks the actions taken by users in an auditable log."
  },
  {
    "key": 4,
    "value": "Administrative controls",
    "description": "Controls that include the processes put in place to manage technology in a secure manner."
  },
  {
    "key": 5,
    "value": "Advanced persistent threat (APT)",
    "description": "A sophisticated, prolonged cyberattack campaign typically conducted by well-funded threat actors, such as nation-states, targeting specific organizations to steal data or monitor activities over an extended period."
  },
  {
    "key": 6,
    "value": "Algorithmic bias",
    "description": "Systematic and repeatable errors in an AI or machine learning system that produce unfair or discriminatory outcomes, often arising from biased training data, flawed model assumptions, or unrepresentative datasets."
  },
  {
    "key": 7,
    "value": "Annualized loss expectancy (ALE)",
    "description": "The possible yearly cost of all instances of a specific realized threat against a specific asset. The ALE is calculated using the formula ALE = single loss expectancy (SLE) * annualized rate of occurrence (ARO)."
  },
  {
    "key": 8,
    "value": "Annualized rate of occurrence (ARO)",
    "description": "The expected frequency that a specific threat or risk will occur (in other words, become realized) within a single year. Also known as probability determination."
  },
  {
    "key": 9,
    "value": "Artificial intelligence (AI)",
    "description": "The branch of computer science focused on building systems that perform tasks typically requiring human intelligence, such as reasoning, learning, perception, and decision-making."
  },
  {
    "key": 10,
    "value": "Asset value (AV)",
    "description": "A dollar value assigned to an asset based on actual cost and nonmonetary expenses."
  },
  {
    "key": 11,
    "value": "Asymmetric key algorithms",
    "description": "Cryptographic algorithms that use two different keys from the same pair: one key to encrypt and another to decrypt. Also called public key cryptography."
  },
  {
    "key": 12,
    "value": "Attribute-based access control (ABAC)",
    "description": "An access control model that makes authorization decisions based on attributes associated with users, resources, actions, and environmental conditions."
  },
  {
    "key": 13,
    "value": "Authentication",
    "description": "Verifies the claimed identity of system users."
  },
  {
    "key": 14,
    "value": "Authorization",
    "description": "Verifies that an authenticated user is allowed to perform a particular action."
  },
  {
    "key": 15,
    "value": "Availability",
    "description": "Ensures that information and systems are ready to meet the needs of legitimate users at the time those users request them."
  },
  {
    "key": 16,
    "value": "Backdoor",
    "description": "An undocumented method of bypassing normal authentication or security controls to gain remote access to a system."
  },
  {
    "key": 17,
    "value": "Baseline",
    "description": "A snapshot of a system or application at a given point in time, used to assess whether changes have occurred outside of an approved change management process."
  },
  {
    "key": 18,
    "value": "Behavior-based detection",
    "description": "An intrusion discovery mechanism used by intrusion detection systems (IDSs). Behavior-based detection finds out about the normal activities and events on your system by watching and learning. After it has accumulated enough data about normal activity, it can detect abnormal and possible malicious activities and events. Also known as statistical intrusion detection, anomaly detection, and heuristics-based detection."
  },
  {
    "key": 19,
    "value": "Biometrics",
    "description": "Authentication mechanisms that measure a physical characteristic of the user."
  },
  {
    "key": 20,
    "value": "Bluetooth",
    "description": "A wireless standard commonly used to pair accessories to mobile phones or computers."
  },
  {
    "key": 21,
    "value": "Bollards",
    "description": "Posts or other obstacles that prevent vehicles from moving through an area."
  },
  {
    "key": 22,
    "value": "Botnet",
    "description": "A network of compromised computers controlled remotely by an attacker to conduct coordinated attacks, distribute spam, or perform other malicious activities."
  },
  {
    "key": 23,
    "value": "Business continuity",
    "description": "Activities designed to keep a business running in the face of adverse events."
  },
  {
    "key": 24,
    "value": "Business impact analysis (BIA)",
    "description": "A formal process designed to identify the mission-essential functions within an organization and facilitate the identification of the critical systems that support those functions."
  },
  {
    "key": 25,
    "value": "Change management",
    "description": "A structured process for requesting, reviewing, approving, and implementing changes to an organization’s technology environment while minimizing risk and disruption."
  },
  {
    "key": 26,
    "value": "Clearing",
    "description": "A data sanitization technique that overwrites sensitive data on storage media with nonsensitive data, rendering it unreadable through normal means."
  },
  {
    "key": 27,
    "value": "Cloud computing",
    "description": "The delivery of computing services over a network, providing on-demand access to shared pools of configurable resources such as servers, storage, and applications."
  },
  {
    "key": 28,
    "value": "Cold sites",
    "description": "Standby facilities that provide space with appropriate electrical and environmental support systems but do not contain any pre-installed computing equipment or telecommunications circuits. Cold sites are the least expensive option but require the longest recovery time."
  },
  {
    "key": 29,
    "value": "Community cloud",
    "description": "A cloud deployment model where infrastructure is shared among several organizations with common interests, requirements, or compliance obligations."
  },
  {
    "key": 30,
    "value": "Compensating controls",
    "description": "Alternative security measures implemented when primary controls cannot be used, providing equivalent protection against a given threat."
  },
  {
    "key": 31,
    "value": "Confidentiality",
    "description": "Ensures that unauthorized individuals are not able to gain access to sensitive information."
  },
  {
    "key": 32,
    "value": "Configuration management",
    "description": "The process of tracking and controlling changes to the configuration of systems and software to maintain security and ensure consistency across the environment."
  },
  {
    "key": 33,
    "value": "Containment",
    "description": "Prevention of the spread of malicious code or other attacks."
  },
  {
    "key": 34,
    "value": "Cryptography",
    "description": "Algorithms applied to data that are designed to ensure confidentiality, integrity, authentication, and/or non-repudiation. The art of creating and implementing secret codes and ciphers."
  },
  {
    "key": 35,
    "value": "Data anonymization",
    "description": "The process of permanently removing all identifying information from a dataset, making it impossible to trace data back to specific individuals."
  },
  {
    "key": 36,
    "value": "Data leakage",
    "description": "The unauthorized or unintentional transfer of sensitive data from inside an organization to an external destination or recipient."
  },
  {
    "key": 37,
    "value": "Data minimization",
    "description": "A privacy principle requiring organizations to collect and retain only the minimum amount of personal information necessary to accomplish their stated purpose."
  },
  {
    "key": 38,
    "value": "Data retention policy",
    "description": "A policy defining how long different types of records and data must be preserved and when they should be securely destroyed."
  },
  {
    "key": 39,
    "value": "Degaussing",
    "description": "A data destruction technique that uses a strong magnetic field to erase data on magnetic storage media, erasing the data on tapes for later reuse, and rendering HDD drives unusable in addition to erasing their data."
  },
  {
    "key": 40,
    "value": "Demilitarized zone (DMZ)",
    "description": "A network zone, also known as a screened subnet, that resides between an internal network and the Internet used to host systems, such as customer-facing web servers, that require public access."
  },
  {
    "key": 41,
    "value": "Denial-of-service (DoS) attacks",
    "description": "Attacks that disrupt normal access to systems or information."
  },
  {
    "key": 42,
    "value": "Detective controls",
    "description": "Controls that identify potential security breaches after they have occurred and require further investigation."
  },
  {
    "key": 43,
    "value": "Differential backup",
    "description": "A type of backup that stores all files that have been modified since the time of the most recent full backup."
  },
  {
    "key": 44,
    "value": "Digital signatures",
    "description": "Encrypted message digests that are created upon the transmission of a message and used to verify both the integrity and authenticity of the message. Digital signatures use asymmetric cryptography to provide non-repudiation."
  },
  {
    "key": 45,
    "value": "Disaster recovery planning (DRP)",
    "description": "Describes the actions an organization takes to resume normal operations after a disaster interrupts normal activity."
  },
  {
    "key": 46,
    "value": "Discretionary access control",
    "description": "A mechanism used to control access to objects. The owner or creator of an object controls and defines the access other subjects have to it."
  },
  {
    "key": 47,
    "value": "Distributed denial-of-service (DDoS) attacks",
    "description": "A denial-of-service attack that originates from multiple coordinated sources, typically using a botnet of compromised systems to overwhelm a target with traffic. DDoS attacks are difficult to defend against because the traffic comes from many different systems simultaneously."
  },
  {
    "key": 48,
    "value": "Domain Name System (DNS)",
    "description": "A hierarchical naming system that translates human-readable domain names into IP addresses used by networked devices to communicate."
  },
  {
    "key": 49,
    "value": "Dumpster diving",
    "description": "Looking through trash for clues, often in the form of paper scraps, to find users’ passwords and other pertinent information."
  },
  {
    "key": 50,
    "value": "Dynamic Host Configuration Protocol (DHCP)",
    "description": "A protocol used to assign TCP/IP configuration settings to systems at bootup. DHCP uses UDP port 67 for client request broadcast and port 68 for server response. DHCP supports centralized control and management of network addressing."
  },
  {
    "key": 51,
    "value": "Elasticity",
    "description": "The ability of a cloud computing environment to automatically scale computing resources up or down based on changing demand."
  },
  {
    "key": 52,
    "value": "Encryption",
    "description": "The process of converting plaintext, which is readable by anyone, into encrypted text or ciphertext. This ciphertext will be unreadable to anyone able to intercept it. The general rule is that all encryption can be broken if an attacker has enough time and resources. That said, the idea is to use encryption that is stronger than the data is valuable."
  },
  {
    "key": 53,
    "value": "Escalation procedures",
    "description": "Processes that define how and when security incidents are elevated to higher levels of management or specialized response teams for appropriate action."
  },
  {
    "key": 54,
    "value": "Evidence preservation",
    "description": "The process of collecting, protecting, and documenting data related to security incidents to maintain its integrity for investigation and potential legal proceedings."
  },
  {
    "key": 55,
    "value": "Exposure factor (EF)",
    "description": "The percentage of loss that an organization would experience if a specific asset were compromised by a realized threat."
  },
  {
    "key": 56,
    "value": "Extranet",
    "description": "A controlled private network segment that allows authorized external parties, such as vendors or business partners, to access specific organizational resources."
  },
  {
    "key": 57,
    "value": "Fault tolerance",
    "description": "Protects a single system from failing by making it resilient in the face of technical failures."
  },
  {
    "key": 58,
    "value": "Firewall",
    "description": "A network security device that blocks unwanted traffic from entering the network."
  },
  {
    "key": 59,
    "value": "Full backup",
    "description": "A complete copy of data contained on the protected device on the backup media."
  },
  {
    "key": 60,
    "value": "Function as a service (FaaS)",
    "description": "An example of platform as a service (PaaS) computing that allows customers to upload their own code functions to the provider; the provider will then execute those functions on a scheduled basis, in response to events and/or on demand."
  },
  {
    "key": 61,
    "value": "Governance, risk, and compliance (GRC)",
    "description": "An integrated approach to managing organizational security through aligned governance structures, risk management processes, and adherence to applicable laws, regulations, and standards."
  },
  {
    "key": 62,
    "value": "Guideline",
    "description": "A document that offers recommendations on how standards and baselines are implemented. Guidelines outline methodologies, including suggested actions, and are not compulsory."
  },
  {
    "key": 63,
    "value": "Hallucination",
    "description": "In generative AI, an output that appears plausible and confident but is factually incorrect, fabricated, or unsupported by the model’s training data or input context."
  },
  {
    "key": 64,
    "value": "Hash functions",
    "description": "Take a potentially long message and generate a unique output value derived from the content of the message."
  },
  {
    "key": 65,
    "value": "Hashing",
    "description": "The creation of a message digest from a message using a one-way cryptographic hash function."
  },
  {
    "key": 66,
    "value": "High availability (HA)",
    "description": "The capability of a service, system, network, or other element of infrastructure to be consistently available without downtime."
  },
  {
    "key": 67,
    "value": "Host-based intrusion detection system (HIDS)",
    "description": "Analyzes traffic before services or applications on the host process it, but it cannot take action to block traffic. Instead, it reports and alerts on issues."
  },
  {
    "key": 68,
    "value": "Host-based intrusion prevention system (HIPS)",
    "description": "Analyzes traffic before services or applications on the host process it. It can take action on that traffic, including filtering out malicious traffic or blocking specific elements of the data that is received."
  },
  {
    "key": 69,
    "value": "Hot site",
    "description": "A configuration in which a backup facility is maintained in constant working order, with a full complement of servers, workstations, and communications links ready to assume primary operations responsibilities."
  },
  {
    "key": 70,
    "value": "Hybrid cloud",
    "description": "A cloud deployment model that combines both public and private cloud resources, allowing data and applications to move between the two environments."
  },
  {
    "key": 71,
    "value": "Impersonation",
    "description": "Pretending to be someone else in order to gain information."
  },
  {
    "key": 72,
    "value": "Impossible travel",
    "description": "An access pattern in which a single user account authenticates from two geographically distant locations within a time interval too short to physically travel between them, often indicating a compromised account."
  },
  {
    "key": 73,
    "value": "Incident response team",
    "description": "A group of trained personnel responsible for detecting, analyzing, containing, eradicating, and recovering from security incidents."
  },
  {
    "key": 74,
    "value": "Incremental backup",
    "description": "A backup that stores only those files that have been modified since the time of the most recent full or incremental backup. This term is also used to mean the process of creating such a backup."
  },
  {
    "key": 75,
    "value": "Indicator of compromise (IoC)",
    "description": "An artifact or piece of forensic evidence, such as a malicious IP address, file hash, or domain name, that suggests a system or network has been breached."
  },
  {
    "key": 76,
    "value": "Industrial control systems (ICS)",
    "description": "Specialized computing systems used to monitor and manage physical processes in industrial environments such as manufacturing, utilities, and critical infrastructure."
  },
  {
    "key": 77,
    "value": "Information classification",
    "description": "The process of determining what information is accessible to what parties and for what purposes."
  },
  {
    "key": 78,
    "value": "Infrastructure as a service (IaaS)",
    "description": "A model of cloud computing that utilizes virtualization; clients pay an outsourcer for the resources used."
  },
  {
    "key": 79,
    "value": "Integrity",
    "description": "Ensures that there are no unauthorized modifications to information or systems, either intentionally or unintentionally."
  },
  {
    "key": 80,
    "value": "Internet of Things (IoT)",
    "description": "A broad term that describes network-connected devices that are used for automation, sensors, security, and similar tasks."
  },
  {
    "key": 81,
    "value": "Intranet",
    "description": "An organization’s internal private network used to host systems, applications, and resources accessible only to authorized employees."
  },
  {
    "key": 82,
    "value": "Intrusion detection system (IDS)",
    "description": "A product that automates the inspection of audit logs and real-time system events. IDSs are generally used to detect intrusion attempts, but they can also be employed to detect system failures or to rate overall performance."
  },
  {
    "key": 83,
    "value": "Intrusion prevention system (IPS)",
    "description": "A tool designed to detect the attempts to gain unauthorized access and prevent the attempts from becoming successful."
  },
  {
    "key": 84,
    "value": "Key performance indicator (KPI)",
    "description": "A measurable value that evaluates how effectively a security program is achieving its objectives."
  },
  {
    "key": 85,
    "value": "Key risk indicator (KRI)",
    "description": "A metric used to provide an early warning signal of increasing risk exposure before incidents occur."
  },
  {
    "key": 86,
    "value": "Large language model (LLM)",
    "description": "A type of artificial intelligence model trained on massive volumes of text data to understand, generate, and process natural language for tasks such as conversation, summarization, and translation."
  },
  {
    "key": 87,
    "value": "Least privilege",
    "description": "Granting the least amount of authorization to users so that they can perform their work tasks but nothing else."
  },
  {
    "key": 88,
    "value": "Legacy systems",
    "description": "Outdated hardware or software that remains in use despite the availability of newer technology, often posing security risks due to lack of vendor support or patching."
  },
  {
    "key": 89,
    "value": "Load balancing",
    "description": "The practice of distributing network traffic or computing workload across multiple servers or resources to optimize performance, ensure availability, and provide redundancy."
  },
  {
    "key": 90,
    "value": "Machine learning (ML)",
    "description": "A subset of artificial intelligence in which systems learn patterns from data and improve their performance on a task over time without being explicitly programmed."
  },
  {
    "key": 91,
    "value": "Malware",
    "description": "A broad term for malicious software designed to damage, disrupt, or gain unauthorized access to computer systems. Common types include viruses, worms, Trojan horses, ransomware, and rootkits."
  },
  {
    "key": 92,
    "value": "Man-in-the-middle attack (MitM)",
    "description": "An attack that occurs when someone/something that is trusted intercepts packets and retransmits them to another party. Also known as an on-path attack."
  },
  {
    "key": 93,
    "value": "Mandatory access control (MAC)",
    "description": "An access control mechanism that uses security labels to regulate subject access to objects. Implementations include using a hierarchical MAC environment, a compartmentalized MAC environment, and a hybrid MAC environment."
  },
  {
    "key": 94,
    "value": "Media sanitization",
    "description": "The process of rendering data on electronic or physical storage media unrecoverable through methods such as clearing, purging, cryptographic erasure, or physical destruction."
  },
  {
    "key": 95,
    "value": "Memorandum of agreement (MOA)",
    "description": "A formal document that outlines the terms and details of an agreement between parties, establishing a mutual understanding of the roles and responsibilities in fulfilling specific objectives."
  },
  {
    "key": 96,
    "value": "Memorandum of understanding (MOU)",
    "description": "A document expressing a mutual understanding of intent between two or more parties regarding a planned course of action. MOUs are less formal than contracts and may not be legally binding."
  },
  {
    "key": 97,
    "value": "Microsegmentation",
    "description": "A network security technique that divides a network into very small, isolated segments, allowing granular control over traffic flow between workloads."
  },
  {
    "key": 98,
    "value": "Model drift",
    "description": "The gradual decline in a machine learning model’s predictive accuracy over time as real-world data diverges from the data on which the model was originally trained."
  },
  {
    "key": 99,
    "value": "Model poisoning",
    "description": "An adversarial attack in which a threat actor manipulates the training data or training process of a machine learning model to introduce vulnerabilities, backdoors, or biased behavior."
  },
  {
    "key": 100,
    "value": "Multifactor authentication (MFA)",
    "description": "Authentication that relies on two or more distinct authentication factors from the set of something you know, something you have, and something you are."
  },
  {
    "key": 101,
    "value": "Near-field communication (NFC)",
    "description": "An extremely short-range wireless communication technology that enables data exchange between devices placed within a few centimeters of each other."
  },
  {
    "key": 102,
    "value": "Network access control (NAC)",
    "description": "Focuses on determining whether a system or device should be allowed to connect to a network."
  },
  {
    "key": 103,
    "value": "Network segmentation",
    "description": "The practice of dividing a computer network into smaller subnetworks, or segments, to improve security by limiting the scope of potential breaches."
  },
  {
    "key": 104,
    "value": "Non-repudiation",
    "description": "A security property ensuring that the sender of a message or the performer of an action cannot later deny having sent the message or performed the action."
  },
  {
    "key": 105,
    "value": "On-path attack",
    "description": "An attack that occurs when someone/something that is trusted intercepts packets and retransmits them to another party. Also known as a man-in-the-middle attack."
  },
  {
    "key": 106,
    "value": "Open-source intelligence (OSINT)",
    "description": "Threat intelligence gathered from publicly available sources such as websites, social media, government reports, and other open data."
  },
  {
    "key": 107,
    "value": "Orphaned accounts",
    "description": "User accounts that remain active after the associated individual has left the organization, creating a potential security vulnerability."
  },
  {
    "key": 108,
    "value": "Password complexity",
    "description": "A security setting that enforces a specific requirement, such as requiring specific character types, not allowing dictionary words, or other attempts to ensure that the password is not easily cracked."
  },
  {
    "key": 109,
    "value": "Password history",
    "description": "A list of passwords that have already been used."
  },
  {
    "key": 110,
    "value": "Password policy",
    "description": "A document that specifies requirements for password length, complexity, reuse, and similar issues."
  },
  {
    "key": 111,
    "value": "Password reuse",
    "description": "Repeating the use of a password, often on unrelated systems. In the event of a breach, password reuse means multiple systems or services could be breached using the same account and password."
  },
  {
    "key": 112,
    "value": "Password spraying attack",
    "description": "An attack in which the attacker uses the same password against many different accounts, then uses another password against many accounts, continuing to attempt breaches until their goal is met or they are unable to log in."
  },
  {
    "key": 113,
    "value": "Password standards",
    "description": "Set forth requirements for password length, complexity, reuse, and similar issues."
  },
  {
    "key": 114,
    "value": "Password vaults",
    "description": "Software solutions that store, manage, and secure passwords and other information, allowing users to use strong passwords without memorizing dozens or hundreds of individual complex passwords."
  },
  {
    "key": 115,
    "value": "Patch management",
    "description": "The process of identifying, acquiring, testing, and applying software updates and security patches to operating systems and applications to address known vulnerabilities."
  },
  {
    "key": 116,
    "value": "Personally identifiable information (PII)",
    "description": "Any data item that is linked back to the human from whom it was gleaned."
  },
  {
    "key": 117,
    "value": "Phishing",
    "description": "A social engineering attack that uses fraudulent emails, messages, or websites to trick individuals into revealing sensitive information or installing malicious software."
  },
  {
    "key": 118,
    "value": "Physical controls",
    "description": "Controls that impact the physical world."
  },
  {
    "key": 119,
    "value": "Platform as a service (PaaS)",
    "description": "A cloud service model in which the consumer can deploy tools using a platform but does not manage or control any of the underlying cloud infrastructure."
  },
  {
    "key": 120,
    "value": "Playbook",
    "description": "Describes the actions that the organization’s incident response team will take when specific types of incidents occur."
  },
  {
    "key": 121,
    "value": "Policy",
    "description": "Documents that outline the foundation of a security program. Compliance with policies is mandatory."
  },
  {
    "key": 122,
    "value": "Preventive controls",
    "description": "Controls designed to stop a security issue from occurring in the first place."
  },
  {
    "key": 123,
    "value": "Private cloud",
    "description": "A cloud delivery model owned and managed internally."
  },
  {
    "key": 124,
    "value": "Privilege creep",
    "description": "The gradual accumulation of unnecessary access rights that occurs as users change roles within an organization without having previous permissions revoked."
  },
  {
    "key": 125,
    "value": "Privileged access management (PAM)",
    "description": "Security tools and practices used to monitor, control, and audit accounts that have elevated access privileges within an organization’s systems."
  },
  {
    "key": 126,
    "value": "Procedure",
    "description": "In the context of security, a detailed step-by-step how-to document describing the actions necessary to implement a specific security mechanism, control, or solution."
  },
  {
    "key": 127,
    "value": "Protected health information (PHI)",
    "description": "Data item that includes medical records maintained by health-care providers and other organizations that are subject to the Health Insurance Portability and Accountability Act (HIPAA)."
  },
  {
    "key": 128,
    "value": "Pseudonymization",
    "description": "A data protection technique that replaces identifying information with artificial identifiers while retaining the ability to re-identify individuals when necessary."
  },
  {
    "key": 129,
    "value": "Public cloud",
    "description": "A cloud delivery model available to others."
  },
  {
    "key": 130,
    "value": "Public key algorithms",
    "description": "See asymmetric key algorithms."
  },
  {
    "key": 131,
    "value": "Public key cryptosystems",
    "description": "Rely on pairs of keys assigned to each user of the cryptosystem."
  },
  {
    "key": 132,
    "value": "Public key infrastructure (PKI)",
    "description": "A hierarchy of trust relationships. These trusts permit combining asymmetric cryptography with symmetric cryptography along with hashing and digital certificates, giving hybrid cryptography."
  },
  {
    "key": 133,
    "value": "Purging",
    "description": "A data sanitization technique that uses advanced methods, such as cryptographic erasure, to render data completely unrecoverable even with specialized forensic tools."
  },
  {
    "key": 134,
    "value": "Qualitative risk assessment",
    "description": "A kind of risk assessment that substitutes subjective judgments and categories for strict numerical analysis, allowing the assessment of risks that are difficult to quantify."
  },
  {
    "key": 135,
    "value": "Quantitative risk assessment",
    "description": "A kind of risk assessment that uses numeric data in the analysis, resulting in assessments that allow the straightforward prioritization of risks."
  },
  {
    "key": 136,
    "value": "Ransomware",
    "description": "A type of malicious software that encrypts a victim’s files or locks system access and demands a ransom payment in exchange for restoring access."
  },
  {
    "key": 137,
    "value": "Recovery controls",
    "description": "Controls designed to remediate security issues that have already occurred."
  },
  {
    "key": 138,
    "value": "Recovery point objective (RPO)",
    "description": "A measure of how much loss can be accepted by the organization when a disaster occurs. RPO is the maximum amount of time that can elapse between backups, thus determining how much data could be lost in a disaster."
  },
  {
    "key": 139,
    "value": "Recovery time objective (RTO)",
    "description": "The amount of time in which you think you can feasibly recover functionality in the event of a disruption."
  },
  {
    "key": 140,
    "value": "Replay attack",
    "description": "A network attack in which an attacker captures valid data transmissions and retransmits them to gain unauthorized access or perform unauthorized actions."
  },
  {
    "key": 141,
    "value": "Residual risk",
    "description": "The level of risk that remains after security controls have been applied to reduce the inherent risk of a threat."
  },
  {
    "key": 142,
    "value": "Risk",
    "description": "The seriousness of an event to an organization based on a combination of the likelihood of that event occurring and the negative impact of the event if it does occur."
  },
  {
    "key": 143,
    "value": "Risk acceptance",
    "description": "A risk management option that involves deliberately choosing to take no other risk management strategy and to continue operations as normal in the face of the risk."
  },
  {
    "key": 144,
    "value": "Risk appetite",
    "description": "An organization’s willingness to tolerate risk within the environment."
  },
  {
    "key": 145,
    "value": "Risk assessment",
    "description": "The process of identifying, analyzing, and evaluating risks to an organization’s information assets. A risk assessment considers the likelihood and impact of potential threats exploiting vulnerabilities to determine appropriate security controls."
  },
  {
    "key": 146,
    "value": "Risk avoidance",
    "description": "The process of selecting alternate options or activities that have less associated risk than the default, common, expedient, or cheap option."
  },
  {
    "key": 147,
    "value": "Risk calculation",
    "description": "The process of calculating the risks that exist in terms of costs, number, frequency, and so forth."
  },
  {
    "key": 148,
    "value": "Risk event reports",
    "description": "Focused on documenting specific risk events, such as security breaches or incidents, their impacts, and the responses taken."
  },
  {
    "key": 149,
    "value": "Risk identification process",
    "description": "The process of identifying the threats and vulnerabilities that exist in the operating environment."
  },
  {
    "key": 150,
    "value": "Risk management",
    "description": "A detailed process of identifying factors that could damage or disclose data, evaluating those factors in light of data value and countermeasure cost, and implementing cost-effective solutions for mitigating or reducing risk."
  },
  {
    "key": 151,
    "value": "Risk management framework (RMF)",
    "description": "A mandatory standard for federal agencies that provides a formalized process that federal agencies must follow to select, implement, and assess risk-based security and privacy controls."
  },
  {
    "key": 152,
    "value": "Risk matrix",
    "description": "An approach that quickly summarizes risks and allows senior leaders to focus on the most significant risks facing the organization."
  },
  {
    "key": 153,
    "value": "Risk mitigation",
    "description": "The implementation of safeguards and countermeasures to eliminate vulnerabilities or block threats."
  },
  {
    "key": 154,
    "value": "Risk owner",
    "description": "An individual or entity responsible for managing and monitoring risks, including implementing necessary controls and actions to mitigate them."
  },
  {
    "key": 155,
    "value": "Risk register",
    "description": "The primary tool that risk management professionals use to track risks facing the organization."
  },
  {
    "key": 156,
    "value": "Risk reporting",
    "description": "An essential component of the risk management process that involves communicating the status and evolution of risks to stakeholders within the organization."
  },
  {
    "key": 157,
    "value": "Risk threshold",
    "description": "The specific level at which a risk becomes unacceptable."
  },
  {
    "key": 158,
    "value": "Risk tolerance",
    "description": "An organization’s ability to withstand risks and continue operations without any significant impact."
  },
  {
    "key": 159,
    "value": "Risk transference",
    "description": "A strategy of dealing with risk in which it is decided that the best approach is to offload some of the risk through insurance, third-party contracts, and/or shared responsibility."
  },
  {
    "key": 160,
    "value": "Risk trend analysis",
    "description": "A reporting form that involves analyzing historical data to identify patterns or trends in the risks faced by the organization."
  },
  {
    "key": 161,
    "value": "Role-based access control (RBAC)",
    "description": "A form of nondiscretionary access control that employs job function roles to regulate subject access to objects."
  },
  {
    "key": 162,
    "value": "Rootkit",
    "description": "A type of malicious software that provides an attacker with privileged access to a system while actively concealing its presence from detection tools."
  },
  {
    "key": 163,
    "value": "Scalability",
    "description": "The ability of a system or infrastructure to handle growing workloads by adding resources, either by increasing the capacity of existing systems or by adding more systems."
  },
  {
    "key": 164,
    "value": "Secure Shell (SSH)",
    "description": "A cryptographic network protocol used for secure remote access, command execution, and encrypted data communication over an unsecured network."
  },
  {
    "key": 165,
    "value": "Security awareness",
    "description": "Security awareness programs help to ensure that the employees and other stakeholders are aware of their information security responsibilities and that those responsibilities remain top-of-mind."
  },
  {
    "key": 166,
    "value": "Security information and event management (SIEM)",
    "description": "A security system or appliance used for monitoring, analysis, and correlation of log and security data."
  },
  {
    "key": 167,
    "value": "Security orchestration, automation, and response (SOAR)",
    "description": "Technology platforms that integrate security tools and automate incident response workflows, allowing security teams to respond to threats more efficiently across multiple systems."
  },
  {
    "key": 168,
    "value": "Security training",
    "description": "Ensures that users in an organization understand the risks associated with the computing environment and their role in minimizing those risks."
  },
  {
    "key": 169,
    "value": "Security vestibule",
    "description": "A physical access control mechanism consisting of a small room with two interlocking doors that allows only one person to pass through at a time, preventing tailgating. Also known as a mantrap."
  },
  {
    "key": 170,
    "value": "Segregation of duties",
    "description": "A set of policies designed to reduce the risk of fraud and prevent other losses in an organization."
  },
  {
    "key": 171,
    "value": "Service-level agreements (SLAs)",
    "description": "Written contracts that specify the conditions of service that will be provided by the vendor and the remedies available to the customer if the vendor fails to meet the SLA."
  },
  {
    "key": 172,
    "value": "Shredding",
    "description": "A physical data destruction method that cross-cuts paper documents or physically destroys storage media into pieces too small to reconstruct."
  },
  {
    "key": 173,
    "value": "Signature-based detection",
    "description": "The process used by antivirus software to identify potential virus infections on a system."
  },
  {
    "key": 174,
    "value": "Single loss expectancy (SLE)",
    "description": "The cost associated with a single realized risk against a specific asset. The SLE indicates the exact amount of loss an organization would experience if an asset were harmed by a specific threat. SLE = asset value ($) * exposure factor (EF)."
  },
  {
    "key": 175,
    "value": "Single point of failure",
    "description": "Any one item, element, or pathway that could cause significant downtime or system failure if broken, offline, or overloaded."
  },
  {
    "key": 176,
    "value": "Social engineering",
    "description": "Attacks that use psychological techniques to persuade an employee to give an attacker sensitive information or access to internal systems."
  },
  {
    "key": 177,
    "value": "Software as a service (SaaS)",
    "description": "A derivative of platform as a service that provides on-demand online access to specific software applications or suites without the need for local installation (or even local hardware and operating system requirements, in many cases)."
  },
  {
    "key": 178,
    "value": "Something you are",
    "description": "Relies on a physical characteristic of the person who is authenticating themselves. Fingerprints, retina scans, voice prints, and even your typing speed and patterns are all included as options for this type of factor."
  },
  {
    "key": 179,
    "value": "Something you have",
    "description": "Includes a smartcard, USB or Bluetooth token, or another object or item that is in your possession."
  },
  {
    "key": 180,
    "value": "Something you know",
    "description": "Includes passwords, PINs, or the answer to a security question."
  },
  {
    "key": 181,
    "value": "Spear phishing",
    "description": "A targeted form of phishing that customizes the attack message for a specific individual, a group of individuals, or organization, using personal details to increase credibility."
  },
  {
    "key": 182,
    "value": "Standards",
    "description": "Documents that define compulsory requirements for the homogenous use of hardware, software, technology, and security controls. They provide a course of action by which technology and procedures are uniformly implemented throughout an organization. Standards are tactical documents that define methods to accomplish the goals and overall direction defined by security policies."
  },
  {
    "key": 183,
    "value": "Supply chain risk management",
    "description": "The process of identifying, assessing, and mitigating risks associated with an organization’s vendors, partners, and service providers."
  },
  {
    "key": 184,
    "value": "Symmetric key cryptography",
    "description": "Any cryptographic algorithm that uses the same key to encrypt and decrypt. Examples include DES, AES, and Blowfish."
  },
  {
    "key": 185,
    "value": "Tabletop exercise",
    "description": "A discussion-based security exercise where participants discuss a simulated incident scenario to test and improve response plans without activating actual systems."
  },
  {
    "key": 186,
    "value": "Tailgating",
    "description": "A physical security attack in which an unauthorized person follows an authorized individual through a secured entrance without presenting valid credentials."
  },
  {
    "key": 187,
    "value": "Technical controls",
    "description": "Controls that use technology to achieve security objectives."
  },
  {
    "key": 188,
    "value": "Threat",
    "description": "A potential occurrence that may cause an undesirable or unwanted outcome for an organization or a specific asset."
  },
  {
    "key": 189,
    "value": "Threat actor",
    "description": "An individual, group, or entity that conducts or intends to conduct malicious activities against an organization’s information systems or assets."
  },
  {
    "key": 190,
    "value": "Threat intelligence",
    "description": "Information about current and emerging threats that is collected, analyzed, and shared to help organizations anticipate and defend against cyberattacks."
  },
  {
    "key": 191,
    "value": "Threat vector",
    "description": "The path or method that an attacker uses to gain access to a target system or network."
  },
  {
    "key": 192,
    "value": "Tokenization",
    "description": "A data protection technique that replaces sensitive data elements with unique, non-exploitable tokens, while the original data is stored securely in a separate system."
  },
  {
    "key": 193,
    "value": "Transmission Control Protocol/Internet Protocol (TCP/IP)",
    "description": "A suite of network protocols used to transfer information between systems in a standardized format. TCP/IP is the primary mechanism used to transport data on modern networks."
  },
  {
    "key": 194,
    "value": "Transport Layer Security (TLS)",
    "description": "A cryptographic protocol that provides secure, encrypted communication over computer networks, commonly used to protect web traffic and other network services."
  },
  {
    "key": 195,
    "value": "Trojan horse",
    "description": "Any application that masquerades as one thing in order to get past scrutiny and then does something malicious. One of the major differences between Trojan horses and viruses is that Trojan horses tend not to replicate themselves."
  },
  {
    "key": 196,
    "value": "Two-person control",
    "description": "A concept that is similar to separation of duties but with an important difference: Instead of preventing the same person from holding two different privileges that are sensitive when used together, two-person control requires the participation of two people to perform a single sensitive action."
  },
  {
    "key": 197,
    "value": "Virtual private network (VPN)",
    "description": "A technology that creates an encrypted connection over an untrusted network, such as the Internet, allowing remote users to securely access organizational resources."
  },
  {
    "key": 198,
    "value": "Virtualization",
    "description": "Technology that creates virtual versions of computing resources such as servers, storage devices, or networks, allowing multiple virtual machines (VMs) to run on a single physical host."
  },
  {
    "key": 199,
    "value": "Virus",
    "description": "A program intended to damage a computer system. It requires user interaction to activate."
  },
  {
    "key": 200,
    "value": "Vishing",
    "description": "A social engineering attack that uses phone calls or voice messages to trick victims into revealing sensitive information."
  },
  {
    "key": 201,
    "value": "VLAN",
    "description": "A logical network segmentation implemented on switches and bridges to manage traffic. Multiple VLANs can be hosted on the same switch but are isolated as though they are separate physical networks. Cross-VLAN communications can occur only through a routing function, often provided by a multilayer switch. VLANs function like physical network segments."
  },
  {
    "key": 202,
    "value": "Vulnerability",
    "description": "A weakness. It can be due to the existence of a flaw, loophole, oversight, error, limitation, frailty, or susceptibility in the IT infrastructure or any other aspect of an organization. It can also be the result of the absence of a safeguard or countermeasure or a weakness in a protection measure."
  },
  {
    "key": 203,
    "value": "Vulnerability assessment",
    "description": "A systematic process of identifying, quantifying, and prioritizing security weaknesses in systems, applications, and network infrastructure."
  },
  {
    "key": 204,
    "value": "Vulnerability management",
    "description": "A program used to detect weaknesses within an organization. Vulnerability scans and vulnerability assessments are two common elements of a vulnerability management program. Vulnerability scans are technical scans performed regularly, and vulnerability assessments are normally combined with a risk assessment."
  },
  {
    "key": 205,
    "value": "Vulnerability scanning",
    "description": "Identifying specific vulnerabilities in your network."
  },
  {
    "key": 206,
    "value": "Warm site",
    "description": "A middle ground between hot sites and cold sites for disaster recovery specialists. A warm site always contains the equipment and data circuits necessary to rapidly establish operations but does not contain up-to-date copies of the client’s data."
  },
  {
    "key": 207,
    "value": "Whaling",
    "description": "A highly targeted form of spear phishing directed at senior executives or other high-value individuals within an organization."
  },
  {
    "key": 208,
    "value": "Wi-Fi",
    "description": "A wireless network operating in the 2.4 GHz, 5 GHz, or 6 GHz frequency bands."
  },
  {
    "key": 209,
    "value": "Wi-Fi Protected Access 2 (WPA2)",
    "description": "A revision of WPA upgrading the encryption to an AES variant known as CCMP. WPA2 can be deployed in personal mode with a preshared key authentication or in enterprise mode using 802.1x to leverage existing network authentication."
  },
  {
    "key": 210,
    "value": "Wi-Fi Protected Access 3 (WPA3)",
    "description": "The replacement for WPA2 that has been required to be supported in all Wi-Fi devices since the middle of 2018."
  },
  {
    "key": 211,
    "value": "Wide area network (WAN)",
    "description": "A network that connects devices or local area networks across large geographic distances, often using leased telecommunications lines or the Internet."
  },
  {
    "key": 212,
    "value": "Worm",
    "description": "A form of malicious code that is self-replicating but that is not designed to impose direct harm on host systems. The primary purpose of a worm is to replicate itself to other systems and gather information. Worms are usually very prolific and often cause a denial of service because of their consumption of system resources and network bandwidth in their attempt to self-replicate."
  },
  {
    "key": 213,
    "value": "Zero-day vulnerability",
    "description": "A previously unknown software vulnerability that is exploited by attackers before the vendor has released a patch or fix."
  },
  {
    "key": 214,
    "value": "Zero Trust (ZT)",
    "description": "A security model that requires strict identity verification for every person and device attempting to access resources, regardless of their location inside or outside the network perimeter."
  }
];
